module.exports = __webpack_public_path__ + "img/Birthday_Cake.c465308.png";